<template>
  <v-list-tile class="pt-4">
    <v-autocomplete
      v-model="model"
      clearable
      dense
      hide-details
      item-text="treeName"
      item-value="id"
      :items="classifications"
      label="Clasificación"
      :loading="loadingClassifications"
      open-on-clear
      prepend-icon="category"
    />
  </v-list-tile>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  computed: {
    ...mapState("featureRules", [
      "classification",
      "classifications",
      "loadingClassifications"
    ]),
    model: {
      get() {
        return this.classification;
      },
      set(id) {
        this.setClassification(id);
      }
    }
  },
  methods: {
    ...mapActions("featureRules", ["getClassifications", "setClassification"])
  },
  created() {
    if (!this.classifications.length) {
      return this.getClassifications();
    }
  }
};
</script>